import { render } from "./MPSIIIBLeukocytes.vue?vue&type=template&id=5bec7ba7&scoped=true"
import script from "./MPSIIIBLeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSIIIBLeukocytes.vue?vue&type=script&lang=js"

import "./MPSIIIBLeukocytes.vue?vue&type=style&index=0&id=5bec7ba7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bec7ba7"]])

export default __exports__